<template>
  <div class="content">
    <div class="bodycontent">
      <div class="tools">
        <div class="tools_title">订单流程设置</div>
        <el-form :model="formData" ref="form1" label-width="160px" size="small">
          <el-form-item label="未支付订单">
            <el-input-number
              :controls="false"
              class="input_small"
              :min="0"
              :max="89"
              v-model="formData.unpaid_days"
            ></el-input-number
            >天
            <el-input-number
              :controls="false"
              class="input_small"
              :min="0"
              :max="23"
              v-model="formData.unpaid_hours"
            ></el-input-number
            >小时
            <el-input-number
              :controls="false"
              class="input_small"
              :min="0"
              :max="59"
              v-model="formData.unpaid_minute"
            ></el-input-number
            >分钟后自动关闭
            <span class="info_text">
              最长可设置90天，货到付款订单不适用
            </span>
          </el-form-item>
          <el-form-item label="已发货订单">
            <el-input
              class="input_medium"
              v-model="formData.send_days"
            ></el-input>
            天后自动确认收货
            <span class="info_text">
              请考虑物流运输时间，最长可设置90天，自提订单在配送方式中设置
            </span>
          </el-form-item>
          <el-form-item label="已收货订单">
            <el-input
              class="input_medium"
              v-model="formData.get_days"
            ></el-input>
            天后关闭退款/退货功能
            <span class="info_text">
              填写则买家可在确认收货后进行退款/退货申请，最长可设置365天，0代表确认收货后无法售后
            </span>
          </el-form-item>
        </el-form>
      </div>
      <div class="tools save">
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GetTimeSetting, SetTimeSetting } from "@/api/order";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      formData: {}
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        store_id: "0",
        merch_id: "0"
      };
      GetTimeSetting(data).then(res => {
        console.log(res);
        if (res.code == 200) {
          if (res.data.length == 0) {
            this.formData.id == "0";
          } else {
            this.formData = Object.assign({}, res.data);
            delete this.formData.merch_id;
            delete this.formData.store_id;
            delete this.formData.create_time;
          }
        }
      });
    },
    save() {
      var data = Object.assign({}, this.formData);
      data.token = this.token;
      data.app_id = this.app_id;
      data.id = data.id ? data.id : "0";
      console.log(data);
      SetTimeSetting(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "保存成功"
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 20px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 0 27px;
    font-size: 14px;
    height: 100%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    display: flex;
    flex-direction: column;
    .save {
      padding-left: 166px;
    }
    .tools {
      padding-top: 20px;
      .tools_title {
        font-size: 15px;
        font-weight: bold;
      }
      .input_small {
        width: 50px;
        margin: 0 6px;
      }
      .input_medium {
        width: 200px;
        margin: 0 6px;
      }
      .info_text {
        margin-left: 30px;
        color: #999;
      }
    }
  }
}
</style>
